import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/logo.png';
var _hoisted_1 = {
  "class": "nav-main-top h-[90px]"
};
var _hoisted_2 = {
  "class": "container nav-header flex justify-between items-center p-2"
};
var _hoisted_3 = {
  "class": "nav flex"
};
var _hoisted_4 = {
  "class": "item px-3"
};
var _hoisted_5 = {
  "class": "item px-3"
};
var _hoisted_6 = {
  "class": "item px-3"
};
var _hoisted_7 = {
  "class": "item px-3"
};
var _hoisted_8 = {
  "class": "item px-3"
};
var _hoisted_9 = {
  "class": "item px-3"
};
var _hoisted_10 = {
  "class": "item px-3"
};
var _hoisted_11 = {
  "class": "item px-3"
};
import { useCommStore } from '@/stores/common';
import { getLocalStorage } from "@/methods/storage";
export default {
  __name: 'm_header',
  setup: function setup(__props) {
    var commonStore = useCommStore();
    var currentPath = commonStore.currentPath || getLocalStorage('hanweilink_url');
    console.log(currentPath);
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        "default": _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createElementVNode("img", {
            src: _imports_0,
            "class": "h-[80px]",
            alt: "苏州汉维"
          }, null, -1)]);
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_link, {
        to: "/",
        "class": _normalizeClass([_unref(currentPath) === '/' || _unref(currentPath) === '/home' ? 'text-(--brand-color)' : '', 'hover:text-(--brand-color)'])
      }, {
        "default": _withCtx(function () {
          return _cache[1] || (_cache[1] = [_createTextVNode("官网首页")]);
        }),
        _: 1
      }, 8, ["class"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
        to: "/bolearnai",
        "class": _normalizeClass([_unref(currentPath) === '/bolearnai' ? 'text-(--brand-color)' : '', 'hover:text-(--brand-color)'])
      }, {
        "default": _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createTextVNode("bolearn AI平台")]);
        }),
        _: 1
      }, 8, ["class"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_link, {
        to: "/bolearnai-train",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createTextVNode("bolearn AI陪练")]);
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_link, {
        to: "/about",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[4] || (_cache[4] = [_createTextVNode("关于我们")]);
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
        to: "/products",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[5] || (_cache[5] = [_createTextVNode("产品和服务")]);
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_link, {
        to: "/solutions",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[6] || (_cache[6] = [_createTextVNode("行业方案")]);
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_router_link, {
        to: "/cases",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[7] || (_cache[7] = [_createTextVNode("应用案例")]);
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_router_link, {
        to: "/contact",
        "class": "hover:text-(--brand-color)"
      }, {
        "default": _withCtx(function () {
          return _cache[8] || (_cache[8] = [_createTextVNode("联系我们")]);
        }),
        _: 1
      })])])])]);
    };
  }
};